import React, { useEffect } from 'react'
import { Form } from 'antd';
import { useFormik } from 'formik';
import { useMutation } from 'react-query';
import { api } from '../../../../../api/api';
import { EducationCourseObj, ObjDB } from '../../../../../types/apiTypes';
import FormStatus from '../../../../../components/form/FormStatus/FormStatus';
import { useFormStatus } from '../../../../../utils/hooks/useFormStatus';
import { EducationCourseFormFields } from '../../../../../types/formFieldTypes';
import EditPlaceholder from '../../../../../components/common/EditPlaceholder/EditPlaceholder';
import { getAntField } from '../../../../../utils/form';
import { educationCourseValidate, clearEducationCourseErrors, initialEducationCourseFields } from '../../formData/EducationCourseFormData';
import { EducationCourseFormInputs } from '../EducationCourseFormInputs/EducationCourseFormInputs';
import { queryKeysEducationCourse } from '../../../../../static/data/queryKeys';
import { invalidateQueries } from '../../../../../utils/rest';


type EducationCourseEditFormProps = {
    editItem: ObjDB<EducationCourseObj> | null
    setOpenedForm: React.Dispatch<React.SetStateAction<boolean>>
    setEditItem: React.Dispatch<React.SetStateAction<ObjDB<EducationCourseObj> | null>>
}

const EducationCourseEditForm: React.FC<React.PropsWithChildren<EducationCourseEditFormProps>> = React.memo((props) => {
    const {
        editItem, setOpenedForm, setEditItem
    } = props

    const formStatus = useFormStatus()

    const {
        errors, values, touched,
        handleChange,
        submitForm, setValues, setErrors,
    } = useFormik<EducationCourseFormFields>({
        initialValues: initialEducationCourseFields,
        onSubmit: (values) => {
            mutate(values)
        },
        validate: educationCourseValidate
    })

    const antField = getAntField<EducationCourseFormFields>(values, errors, touched)

    const {
        mutate
    } = useMutation(
        async (values: EducationCourseFormFields) => {
            if (editItem) return await api.educationCourse.edit(values, editItem)
        },
        {
            mutationKey: 'education-course-edit',
            onSuccess() {
                invalidateQueries(queryKeysEducationCourse[0])
                formStatus.setMessage('Данные успешно изменены')
                formStatus.setStatus('success')
                setTimeout(clearEditItem, 1000)
            },
            onError(err: Error) {
                console.error('ERROR', err)
                formStatus.setMessage(`Ошибка: ${err.message}`)
                formStatus.setStatus('error')
                setTimeout(clearEditItem, 5000)
            },
            onMutate() {
                formStatus.setMessage('Отправка данных')
                formStatus.setStatus('fetching')
            }
        }
    )

    const clearForm = () => {
        setValues(initialEducationCourseFields)
        setErrors(clearEducationCourseErrors)
    }

    const clearEditItem = () => {
        clearForm()
        setOpenedForm(false)
        setTimeout(() => {
            setEditItem(null)
            formStatus.reset()
        }, 300)
    }

    const resetChanges = () => {
        if (editItem) {
            const { id, ...values } = editItem
            setValues(values)
            setErrors(clearEducationCourseErrors)
        }
    }

    useEffect(() => {
        if (editItem) return resetChanges()
        clearForm()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editItem])

    if (!editItem) return <EditPlaceholder />

    return (
        <Form
            fields={[antField('name')]}
        >
            {
                editItem &&
                <p className="uif-ant-form-title">
                    ID редактируемого объекта: <span>{editItem.id}</span>
                </p>
            }
            <EducationCourseFormInputs
                handleChange={handleChange}
                resetChanges={resetChanges}
                submitForm={submitForm}
            />
            <FormStatus formStatus={formStatus} />
        </Form>
    )
})

export default EducationCourseEditForm